import * as React from "react";
const SvgFiBrandsSubstance3DPainter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-substance-3d-painter_svg__a)">
      <path d="M10.816 8.98c.167.268.252.575.243.886q0 .66-.327 1.03a1.8 1.8 0 0 1-.855.532 4.1 4.1 0 0 1-1.199.16h-.554q-.185 0-.403-.015V8.24q.117-.015.427-.024.312-.008.715-.008c.417-.013.834.056 1.224.2.299.115.553.315.729.572" />
      <path d="M20.573.3H4.427C1.982.3 0 2.203 0 4.55v14.9c0 2.347 1.982 4.25 4.427 4.25h16.146c2.445 0 4.427-1.903 4.427-4.25V4.55C25 2.203 23.018.3 20.573.3M12.72 11.944a3.5 3.5 0 0 1-1.677 1.216 6.9 6.9 0 0 1-2.348.378q-.369 0-.52-.008a10 10 0 0 0-.453-.008v3.172c.01.07-.04.135-.114.145a.1.1 0 0 1-.037 0H5.525q-.117 0-.117-.13V6.423q0-.112.101-.112.267 0 .638-.008.367-.01.795-.017l.906-.016q.478-.01.947-.01 1.274 0 2.147.307a3.76 3.76 0 0 1 1.4.82c.337.322.596.709.763 1.136.157.415.237.854.235 1.296q0 1.289-.62 2.126m6.841-1.24H17.97v3.445q0 .547.192.78.193.236.713.234a4 4 0 0 0 .554-.032.11.11 0 0 1 .092.008q.041.024.041.104v1.32q0 .177-.133.209-.331.1-.67.16a4.6 4.6 0 0 1-.806.066q-1.09 0-1.71-.548-.621-.547-.62-1.755v-3.993h-.99q-.134 0-.134-.145V8.966q0-.13.151-.13h.99l.041-.635q.025-.362.068-.724.042-.363.075-.587a.3.3 0 0 1 .049-.09.2.2 0 0 1 .084-.056l1.996-.242c.044-.007.072-.007.093.005.023.01.025.038.025.092q-.035.371-.05 1.006l-.034 1.232h1.56q.1 0 .1.129v1.626a.1.1 0 0 1-.085.112" />
    </g>
    <defs>
      <clipPath id="fi-brands-substance-3d-painter_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsSubstance3DPainter;
